import  ReactDom  from "react-dom";

import './index.css';
import App from "./app";

ReactDom.render(<App/>,document.getElementById('root'));